/**
 * @module funcao/commands/funcaocommand
 */

import { Command } from 'ckeditor5/src/core';

const FUNCAO = 'funcao';

/**
 * The insert funcao command.
 *
 * The command is registered by {@link module:funcao/funcaoediting~FuncaoEditing} as `'funcao'` editor command.
 *
 * To insert a funcao at the current selection, execute the command and specify the type:
 *
 *		editor.execute( 'funcao', { codigo: 1 } );
 *
 * @extends {Command}
 */
export default class FuncaoCommand extends Command {

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
		this._config = editor.config.get( FUNCAO ) || {};

		/**
		 * @type {Map<number, Funcao>}
		 */
		this._funcoes = new Map();
		if ( this._config.lista ) {
			for ( const func of this._config.lista ) {
				this._funcoes.set( func.codigo, func );
			}
		} else {
			this.forceDisabled( 'nothing to do' );
		}
	}

	/**
	 * Executes the command.
	 *
	 * Inserts a funcao with the specified codigo.
	 *
	 * @param {Object} options
	 * @param {number | string} [options.codigo=null] The funcao code to be used funcao.
	 */
	execute( options = {} ) {
		const data = this.editor.data;
		const model = this.editor.model;

		if ( options == null ) {
			options = {};
		}

		const codigo = options.codigo;
		const funcao = this._funcoes.get( codigo );

		if ( funcao == null ) {
			console.error( "Tentando inserir funcao de numero %d nao encontrado.", codigo );
			return;
		}

		const selection = model.document.selection;
		model.change( writer => {
			let element;
			if ( funcao.tipo === 'V' ) {
				element = writer.createElement( FUNCAO, {
					...Object.fromEntries( selection.getAttributes() ),
					data: funcao.descricao
				} );
			} else if ( funcao.tipo === 'S' ) {
				element = writer.createElement( FUNCAO, {
					...Object.fromEntries( selection.getAttributes() ),
					data: funcao.estilo.replace( /{{([^{}"]+)}}/g, '$1' )
				} );
			} else {
				const viewFragment = data.processor.toView( funcao.estilo.replace( /{{([^{}"]+)}}/g, '<span class="funcao" data="$1"></span>' ) );
				element = data.toModel( viewFragment, '$clipboardHolder' );
			}
			model.insertContent( element );
		} );
	}
}
